import initMosaicGallery from '@/modules/misc/common/mosaic-gallery';
import withSlideTransition from '@/modules/misc/common/mosaic-modal-transition';
import initGallerySectionsSlider from '@/modules/public/shared/gallery-sections-slider';

import initMosaicLazyLoading from '../components/mosaic-lazyloading';

export const init = () => {
  let mosaicModal = null;
  let historyHelper = null;
  let sectionsSlider = null;
  let galleryData = null;

  function initHistoryHelper() {
    // init history helper
    historyHelper = App.components.history_state({
      onChange(popEvent, { isOwnTraversal }) {
        if (popEvent.state && typeof popEvent.state === 'string' && popEvent.state.indexOf('lightbox-gallery') === 0) {
          const id = +popEvent.state.replace('lightbox-gallery', '');
          const index = galleryData.findIndex(item => item.id === id);
          window.pswpLightbox.loadAndOpen(index);
        } else if (popEvent?.state === 'mosaic-gallery') {
          mosaicModal.show({ animate: isOwnTraversal });

          if (window.pswpLightbox?.pswp?.isOpen) {
            window.pswpLightbox.pswp.close();
          }
        } else {
          mosaicModal.hide({ animate: isOwnTraversal });
        }
        if (!popEvent.state && window.pswpLightbox?.pswp?.isOpen) {
          window.pswpLightbox.pswp.close();
        }
      },
    });
  }

  function initMosaic() {
    // template
    const template = document.querySelector('#mosaic-gallery').content.cloneNode(true);
    document.body.appendChild(template);

    const mosaicPopup = document.querySelector('.mosaicPopup');
    // init modal
    mosaicModal = withSlideTransition(new App.views.shared.modal(
      mosaicPopup,
      document.querySelector('.mosaicPopupOverlay'),
      {
        onCloseButtonClick: () => {
          historyHelper.back();
        },
      },
    ));

    // esc
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') {
        return;
      }
      if (window.pswpLightbox?.pswp?.isOpen || historyHelper.getState() === 'mosaic-gallery') {
        historyHelper.back();
      }
    });

    // images
    const observer = initMosaicLazyLoading();
    document.querySelectorAll('.mosaicPopup__img').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        const id = +e.currentTarget.dataset.id;
        historyHelper.pushState(`lightbox-gallery${id}`, 'Gallery', '#lightbox-gallery');
        const index = galleryData.findIndex(item => item.id === id);

        if (index >= 0) {
          window.pswpLightbox.loadAndOpen(index);

          App.track.event('venue_page_interaction', {
            section: 'photos_mosaic',
            element: 'photo_preview',
            interaction: 'click',
          });
        }
      });

      observer.observe(el);
    });

    // share button
    if (navigator.share) { // if sharing supported
      const shareButton = document.querySelector('.mosaicPopup__shareButton');
      shareButton.classList.remove('none');
      shareButton.addEventListener('click', (e) => {
        e.preventDefault();

        const venueId = shareButton.dataset.venueId;
        App.track.event('venue_page_interaction', {
          section: 'photos_mosaic',
          element: 'sharing_button',
          element_value: venueId,
          interaction: 'share',
        });

        setTimeout(() => {
          window.navigator.share({
            title: document.querySelector('.mosaicPopup__title').textContent.trim(),
            url: window.location.href,
          });
        }, 250);
      });
    }

    // titles of sections buttons
    const roomTitlesButtons = document.querySelectorAll('.gallerySection__title a');
    roomTitlesButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const roomId = e.currentTarget.dataset.roomId;

        App.track.event('venue_page_interaction', {
          section: 'photos_mosaic',
          element: 'view_space_button',
          element_value: roomId,
          interaction: 'click',
        });
      });
    });

    // slider
    sectionsSlider = initGallerySectionsSlider({
      onSectionClick: ({ sectionSlug, sectionIndex }) => {
        App.track.event('venue_page_interaction', {
          section: 'photos_mosaic',
          element: 'photo_category_thumbnail',
          element_value: sectionSlug.includes('room-') ? `room${sectionIndex}` : sectionSlug,
          interaction: 'click',
        });
      },
    });
  }
  function openMosaic() {
    mosaicModal.show();

    App.track.event('venue_page_interaction', {
      section: 'photos_mosaic',
      element: 'photo_mosaic',
      interaction: 'show',
    });

    sectionsSlider?.showRightChevronIfScrollable();
  }

  const initGallery = () => {
    const galleryEl = document.querySelector('#gallery--mixed-source');
    galleryData = JSON.parse(galleryEl.dataset.galleryItems);

    const lightbox = initMosaicGallery(galleryData);

    lightbox.on('close', () => {
      if (window.location.hash === '#lightbox-gallery') {
        historyHelper.back();
      }
    });

    lightbox.on('afterInit', () => {
      // https://github.com/dimsemenov/PhotoSwipe/issues/2027#issuecomment-1608768886
      document.querySelector('.pswp__container').addEventListener('touchstart', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'back',
        order: 1,
        isButton: false,
        appendTo: 'root',
        html: '<span class="pswp__back__label">Gallery</span>',
        onClick: () => {
          historyHelper.back();
        },
      });
      lightbox.pswp.ui.registerElement({
        name: 'custom-caption',
        order: 2,
        isButton: false,
        appendTo: 'root',
        html: '',
        onInit: (el) => {
          lightbox.pswp.on('change', () => {
            el.innerHTML = lightbox.pswp.currSlide.data.caption;
          });
        },
      });

      lightbox.pswp.ui.registerElement({
        name: 'close-gallery',
        order: 3,
        isButton: false,
        appendTo: 'root',
        html: '<span class="pswp__close__label">Close</span>',
        onClick: () => {
          historyHelper.go(-2);
        },
      });

      if (navigator.share) { // if sharing supported
        lightbox.pswp.ui.registerElement({
          name: 'share',
          order: 4,
          isButton: false,
          appendTo: 'root',
          html: '<span class="pswp__share__label">Share</span>',
          onClick: () => {
            App.track.event('venue_page_interaction', {
              section: 'photos',
              element: 'sharing_button',
              interaction: 'share',
            });

            window.navigator.share({
              title: document.querySelector('.mosaicPopup__title').textContent.trim(),
              url: window.location.href,
            });
          },
        });
      }
    });

    lightbox.on('change', () => {
      App.track.event('venue_page_interaction', {
        section: 'photos',
        element: 'photo_browser',
        element_value: lightbox.pswp.currIndex,
        interaction: 'show',
      });
    });

    lightbox.init();

    // expose to use within onclick attribute
    window.pswpLightbox = lightbox;
  };

  initHistoryHelper();
  initMosaic();
  initGallery();

  if (window.location.hash === '#mosaic-gallery') {
    window.history.replaceState(null, null, ' ');
    historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');
    openMosaic();
  } else if (window.location.hash === '#lightbox-gallery') {
    let id;
    let index;
    if (window.history.state) {
      id = window.history.state.replace('lightbox-gallery', '');
      index = galleryData.findIndex(item => item.id === +id);
    } else {
      index = 0;
      id = galleryData[index].id;
    }

    window.history.replaceState(null, null, ' ');
    historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');
    historyHelper.pushState(`lightbox-gallery${id}`, 'Gallery', '#lightbox-gallery');
    window.pswpLightbox.loadAndOpen(index);
  }

  const mosaicPopup = document.querySelector('.mosaicPopup');

  document.querySelectorAll('.gallery-container').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      openMosaic();
      historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');

      mosaicPopup.scrollTo({ top: 0 });

      const index = e.currentTarget.dataset.index;

      App.track.event('venue_page_interaction', {
        section: 'venue_page_photos',
        element: 'photo_preview',
        element_value: index,
        interaction: 'click',
      });
    });
  });

  const allPhotosButton = document.querySelector('.js-all-photos');
  if (allPhotosButton) {
    allPhotosButton.addEventListener('click', (e) => {
      e.preventDefault();
      openMosaic();
      historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');

      mosaicPopup.scrollTo({ top: 0 });

      const imagesCount = e.target.dataset.trackValue;
      App.track.event('venue_page_interaction', {
        section: 'venue_page_photos',
        element: 'show_all_photos',
        element_value: imagesCount,
        interaction: 'click',
      });
    });
  }
};
